// Function to apply the grey background to 3XL and the specific 2XL variant
function applyGreyBackgroundToSpecialVariants() {
    document.querySelectorAll('label').forEach(function(label) {
        const associatedInput = document.querySelector(`#${label.getAttribute('for')}`);
        // Check if the label contains "3XL" or matches the specific 2XL* data-option-value-id
        if (
            label.textContent.includes('3XL*') || 
            (associatedInput && associatedInput.getAttribute('data-option-value-id') === '4430692647204') // Specific 2XL* ID
        ) {
            label.style.backgroundColor = 'lightgray';
        }
    });
}

// Initial application on page load
document.addEventListener("DOMContentLoaded", function() {
    applyGreyBackgroundToSpecialVariants();

    // Monitor changes in the variants using event delegation
    const formElement = document.querySelector('form[action="/cart/add"]');
    if (formElement) {
        formElement.addEventListener('change', function() {
            // Reapply styles after any change
            applyGreyBackgroundToSpecialVariants();
        });
    }
});
